import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'action-button',
  styleUrls: ['./action-button.component.scss'],
  templateUrl: './action-button.component.html',
})
export class ActionButtonComponent {
  @Input()
  @HostBinding('class.vertical')
  vertical = false;
}
